module.exports = ":host {\n  width: 100%;\n  display: flex; }\n  :host > div {\n    width: 100%;\n    display: flex; }\n"